module.exports = __webpack_public_path__ + "media/images/offer-letter-templates-empty-60596e96786b79ce72ad7f1da0431d87.svg";